import { Component, OnInit, Inject } from '@angular/core';
import { Signatario } from 'src/app/models/signatario';
import { SignatarioService } from 'src/app/services/signatario.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { MASKS } from 'ng-brazil';

@Component({
  selector: 'app-cadastrar-signatario-modal',
  templateUrl: './cadastrar-signatario-modal.component.html',
  styleUrls: ['./cadastrar-signatario-modal.component.scss']
})
export class CadastrarSignatarioModalComponent implements OnInit {
  idSignatario: number;
  idGIContato: number;
  sig: Signatario = new Signatario();
  cadastroContato = false;
  tipos: any[] = [{ id: 0, nome: 'Representante' }, { id: 1, nome: 'Testemunha' }];
  public MASKS = MASKS;
  listaCpfs: string[];

  tipoSelecionado = 0;

  constructor(
    private signatarioService: SignatarioService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private dialogRef: MatDialogRef<CadastrarSignatarioModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.idSignatario = data.idSignatario;
    this.idGIContato = data.idGIContato;
    this.cadastroContato = data.cadastroContato;
    this.listaCpfs = data.listaCpfs;
  }

  ngOnInit(): void {
    if (!this.cadastroContato && this.idSignatario) {
      this.buscarSignatario();
    }
  }

  buscarSignatario() {
    this.carregandoService.mostra("buscarSignatario");
    this.signatarioService.consultar(this.idSignatario).subscribe(
      sig => {
        this.sig = sig;
        this.tipoSelecionado = this.sig.tipo;
        this.carregandoService.esconde("buscarSignatario");
      },
      err => {
        this.carregandoService.esconde("buscarSignatario");
        this.notificacaoService.erro(err);
      }
    );
  }

  salvar() {
    this.sig.tipo = this.tipoSelecionado;

    if (this.cadastroContato) {
      this.verificaCPF(this.sig.cpf);
    }
    else {
      this.sig.idGIContato = this.idGIContato;

      this.carregandoService.mostra("salvar");
      this.signatarioService.salvar(this.sig).subscribe(
        () => {
          this.carregandoService.esconde("salvar");
          this.dialogRef.close(true);
        },
        err => {
          this.carregandoService.esconde("salvar");
          this.notificacaoService.erro(err);
        }
      );
    }
  }

  verificaCPF(cpf: string) {
    if (this.listaCpfs !== null && this.listaCpfs.includes(cpf)) {
      this.notificacaoService.erro("Este CPF já foi usado por um representante anterior");
      return; 
    }

    this.dialogRef.close(this.sig);
    return;
  }

  fechar() {
    this.dialogRef.close();
  }
}
